import React from "react";
import { FaHeart, FaGem, FaUser, FaStar } from "react-icons/fa";
import { MdChildFriendly, } from "react-icons/md";
import "./ASGPathway.css";

const ASGPathway = () => {
  return (
    <div>
      <section className="section-aboutasg">
        <div className="sectiontop-line"></div>
        <h2 className="sectiontitle">ASG PATHWAY</h2>
        <div className="sectionbottom-line"></div>
      </section>
      <div className="pathway-container">
        {/* Download Button */}
        <div className="download-button-container">
          <a href="/files/ASG Pathway-WEB.pdf" download>
            <button className="careo-btn">
              <i className="fas fa-download"></i> Download
            </button>
          </a>
        </div>

        <h2 className="title">ASG EDUCATION PATHWAY</h2>


        <div className="levels">
          {/* LEVEL I */}
          <div className="level-contaner">
            <div className="Level1-Group">
              <div className="level level-1">
                <h3>LEVEL I <MdChildFriendly className="icon" /></h3>
                <div className="course">Probability & Actuarial Statistics (PAS)</div>
                <div className="course">Actuarial Financial Reporting (AFR)</div>
                <div className="course">Actuarial Economics (AE)</div>
              </div>

              {/* LEVEL II */}
              <div className="level level-2">
                <h3>LEVEL II <FaUser className="icon" /></h3>
                <div className="course-II">Financial Mathematics (FM)</div>
                <div className="course-II">Risk & Survival Statistics (RSS)*</div>
              </div>
            </div>
              <div className="arrow-contaner">
                  <div className="arrow-g">
                  <div class="line"></div></div>
              </div>
            <div className="note-1">
              <p>Univ. Accredited Programme (BSc/MSc) OR Exam from ASG-ASSA & IAA Full Member Assoc. (CAS/SOA/IFOA etc)</p>
            </div>
          </div>

          {/* LEVEL III */}
          <div className="level-contaner">
            <div className="Livel2-Group">
              <div className="level level-3">
                <h3>LEVEL III <FaGem className="icon" /></h3>
                <div className="table-divition">
                  <div className="course box1">Contingencies (C)</div>
                  <div className="course box1">Communications (Com)</div>
                </div>
                <div className="table-divition">
                  <div className="course box1">Loss Reserving & Financial Engineering (LRFE)</div>
                  <div className="course box1">Actuarial Risk Management (ARM)</div>
                </div>
                <div className="course box1">Legal Environment & Regulation (LER)</div>
              </div>
            </div>
            <div className="arrow-contaner">
                  <div className="arrow-g">
                  <div class="line"></div></div>
              </div>
            <div className="note-2"><p>ASG-GIC Actuarial Programme</p></div>
          </div>

          {/* LEVEL IV - Normative Skills */}
          <div className="Level3-Group">
              <div className="level-contaner">
                  <div className="level level-4">
                    <h3>LEVEL IV <FaHeart className="icon" /></h3>
                    <h5>Normative Skills</h5>
                    <ul>
                      <li>Modelling Fundamentals (N1)</li>
                      <li>Model Documentation, Analysis & Reporting (N2)</li>
                      <li>General Practice (N3)</li>
                      <li>Professionalism Seminar***</li>
                      <li>Work-Based Learning (WBL)*</li>
                    </ul>
                  </div>
                  <div className="arrow-contaner">
                    <div className="arrow-g">
                    <div class="line"></div></div>
                </div>
                <div className="note-3"><p>Associateship Qualification Training</p></div>
              </div>

              {/* LEVEL IV - Fellowship */}
              <div className="level-contaner">
                  <div className="level level-5">
                    <h3>LEVEL IV <FaStar className="icon" /></h3>
                    <p>Fellowship Exam of ASSA</p>
                  </div>
                <div className="arrow-contaner">
                  <div className="arrow-g">
                  <div class="line"></div></div>
              </div>
                <div className="note-4"><p>Fellowship Pathway</p></div>
              </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default ASGPathway;
